import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
// Limitless imports
import { PortalTextInput } from "@limitless/portal";
const useStyles = makeStyles(theme => ({
  inputField: {
    width: 45,
    background: theme.palette.background.default,
    marginRight: 16
  }
}));
const isNumeric = valInString => !isNaN(parseInt(valInString, 10));
const CodeCollector = ({
  max = 4,
  onUpdate,
  classes = {},
  clearAll = false
}) => {
  var _classes$childWrapper, _classes$inputField;
  const defaultClasses = useStyles();
  const childWrapperClass = (_classes$childWrapper = classes === null || classes === void 0 ? void 0 : classes.childWrapper) !== null && _classes$childWrapper !== void 0 ? _classes$childWrapper : "";
  const inputFieldClass = (_classes$inputField = classes.inputField) !== null && _classes$inputField !== void 0 ? _classes$inputField : defaultClasses.inputField;
  const [codes, setCodes] = React.useState([...Array(max).keys()].map(() => ""));
  const [onMobile, setOnMobile] = React.useState(false);
  React.useEffect(() => {
    if (clearAll === true) {
      setCodes([...Array(max).keys()].map(() => ""));
    }
  }, [clearAll]);
  const refs = React.useRef(new Array(max));
  const handleCodeEnter = (i, value, keyCode, onMobile = false) => {
    if (onMobile || keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105) {
      handleUpdateCode(value, i);
      if (refs.current[i + 1]) {
        refs.current[i + 1].focus();
      }
    } else if (keyCode === 8) {
      handleUpdateCode("", i);
      if (refs.current[i - 1]) {
        refs.current[i - 1].focus();
      }
    }
  };
  const handleUpdateCode = (num, i) => {
    const newCodes = [...codes];
    newCodes[i] = num;
    setCodes(newCodes);
    onUpdate(newCodes.join(""));
  };
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: childWrapperClass
  }, [...Array(max).keys()].map(i => {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      key: i,
      className: inputFieldClass
    }, /*#__PURE__*/React.createElement(PortalTextInput, {
      inputProps: {
        max: 1,
        style: {
          textAlign: "center"
        }
      },
      inputRef: ele => refs.current[i] = ele,
      onKeyDown: event => {
        if (event.keyCode === 229) {
          setOnMobile(true);
          return;
        }
        handleCodeEnter(i, event.key, event.keyCode);
      },
      onChange: event => {
        var _event$target;
        if (!onMobile || !isNumeric(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value)) {
          return;
        }
        handleCodeEnter(i, event.target.value, event.keyCode, onMobile);
      },
      value: codes[i],
      id: `codeInput${i}`,
      variant: "outlined",
      autoFocus: i === 0,
      showHelperText: false
    }));
  }));
};
CodeCollector.propTypes = {
  max: PropTypes.number,
  classes: PropTypes.any,
  clearAll: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired
};
export default CodeCollector;